import React, { useLayoutEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { SplashProvider } from './context/SplashContext';
import LoginPage from './pages/auth/LoginPage';
import AppShell from './pages/AppShell';
import { FullPageSpinner } from './components/LoadingSpinner';

// One module, one audience split by role. There is no module switcher and no sidebar to
// anywhere else — this deployment holds the governance register and nothing else, and
// every additional surface would be additional attack surface.

// Reset the scroll to the top on every route change. Without this the browser keeps the
// previous page's scroll offset — most visibly after sign-in, where the login page's offset
// carried into the home page and it opened part-scrolled with its header off-screen. Keyed on
// pathname (not search/hash) so an in-page anchor still works. useLayoutEffect so it lands
// before paint — no visible jump from mid-page to top.
function ScrollToTop() {
  const { pathname } = useLocation();
  useLayoutEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  // Returning null here left a blank white frame while the session was checked, which on a
  // slow connection is indistinguishable from a broken page.
  if (loading) return <FullPageSpinner />;
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <SplashProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/*" element={<PrivateRoute><AppShell /></PrivateRoute>} />
          </Routes>
        </BrowserRouter>
        </SplashProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
